import {array, mixed, object, string} from 'yup';

import {GeoFilterOption} from '@entities/common';

export const v8nSchema = object().shape({
  name: string().required(),
  geos: array().of(mixed<GeoFilterOption>().required()).defined(),
});

export const createV8nSchema = v8nSchema.shape({
  slug: string().required(),
});

export interface FormValues {
  name: string;
  geos: GeoFilterOption[];
}

export interface CreateFormValues extends FormValues {
  slug: string;
}
